const DEFAULT_PROD_PANEL_URL = 'https://configurador.polgo.com.br';
const DEFAULT_PROD_API_URL = 'https://ws.configurador.polgo.com.br';
const DEFAULT_TEST_API_URL = 'https://testews.configurador.polgo.com.br';

function normalizeUrl(url) {
  return (url || '').replace(/\/$/, '');
}

/**
 * Painel de produção (configurador.polgo.com.br) vs homolog/local.
 */
export function isProdEnvironment() {
  if (typeof window === 'undefined') {
    return process.env.NODE_ENV === 'production';
  }

  const prodUrl = normalizeUrl(process.env.PROD_URL || DEFAULT_PROD_PANEL_URL);
  const href = window.location.href.replace(/^http:/, 'https:');
  return href.startsWith(prodUrl);
}

/**
 * Base URL da API conforme o ambiente do painel (não use NODE_ENV).
 */
export function getApiBaseUrl() {
  //return 'http://localhost:3000';

  const prodApi = normalizeUrl(process.env.WS_URL || DEFAULT_PROD_API_URL);
  const testApi = normalizeUrl(process.env.WS_TEST_URL || DEFAULT_TEST_API_URL);
  return isProdEnvironment() ? prodApi : testApi;
}

/**
 * Interpreta resposta de GET /system/ip-check.
 */
export function parseIpCheckResponse(data) {
  if (!data || typeof data !== 'object') {
    return null;
  }

  const statusCode = data.statusCode ?? data.status?.codigo;
  const payload = data.dados && typeof data.dados === 'object' ? data.dados : data;

  if (statusCode !== 200 || typeof payload.temAcesso !== 'boolean') {
    return null;
  }

  return {
    ip: payload.ip ?? null,
    temAcesso: payload.temAcesso,
  };
}
